/**
 * @coreapi
 * @module view
 */ /** for typedoc */
export * from './interface';
export * from './view';
